"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Unstable_Grid2/Grid2"));
var _Heading = _interopRequireDefault(require("../../../elements/Heading/Heading"));
var _Button = _interopRequireDefault(require("../../../elements/Button/Button"));
var _Link = _interopRequireDefault(require("../../../elements/Link/Link"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _GridTwo = _interopRequireDefault(require("../../../components/Grid/GridTwo/GridTwo"));
var _excluded = ["headingCopy", "subheadingCopy", "buttonLabel", "heroImageUrl", "heroImageAlt", "buttonUrl"];
var _templateObject, _templateObject2, _templateObject3;
var HeroImage = _styledComponents.default.img(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  @media (min-width: ", ") {\n    max-height: 80vw;\n    width: 70%;\n    text-align: right;\n  }\n\n  @media (min-width: ", ") {\n    width: 100%;\n  }\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var StyledSectionHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h1: true,
    teal: true,
    className: className
  }, " ", children, " ");
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var StyledSectionSubheading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return _react.default.createElement(_Heading.default, {
    hsub: true,
    pink: true,
    className: className
  }, " ", children, " ");
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var SkeletalHero = function SkeletalHero(_ref3) {
  var headingCopy = _ref3.headingCopy,
    subheadingCopy = _ref3.subheadingCopy,
    buttonLabel = _ref3.buttonLabel,
    heroImageUrl = _ref3.heroImageUrl,
    heroImageAlt = _ref3.heroImageAlt,
    buttonUrl = _ref3.buttonUrl,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return _react.default.createElement(_GridTwo.default, Object.assign({
    marginless: true,
    direction: 'row-reverse',
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, props), _react.default.createElement(_Grid.default, {
    xs: 12,
    sm: 12,
    md: 7,
    lg: 7,
    style: {
      textAlign: 'right'
    }
  }, _react.default.createElement(HeroImage, {
    src: heroImageUrl,
    alt: heroImageAlt
  })), _react.default.createElement(_Grid.default, {
    xs: 12,
    sm: 12,
    md: 5,
    lg: 5
  }, _react.default.createElement(StyledSectionHeading, null, " ", headingCopy, " "), _react.default.createElement(StyledSectionSubheading, null, " ", subheadingCopy, "  "), _react.default.createElement(_Link.default, {
    href: buttonUrl
  }, _react.default.createElement(_Button.default, {
    teal: true
  }, " ", buttonLabel, " "))));
};
var _default = SkeletalHero;
exports.default = _default;